/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */

import styled from 'styled-components'

export const CardsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	gap: 1rem;
`
export const Container = styled.article`
	padding: 0px 20px 20px;
`
export const ListContainer = styled.div``

export const PageSection = styled.section`
	margin-bottom: 2rem;
`
